import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    templateUrl: './firstClickBudgetDialog.component.html',
    styleUrls: ['./modal.css', './firstClickBudgetDialog.component.css'],
    standalone: false
})
export class FirstClickBudgetDialogComponent implements OnInit {

   constructor(public dialogRef: MatDialogRef<FirstClickBudgetDialogComponent>) { }

    ngOnInit(): void {
        // nothing to initialize yet
    }

    ok(): void {
        this.dialogRef.close(true);
    }

    cancel(): void {
        this.dialogRef.close(false);
    }
}
